import type { IconNode, LucideIcon } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

// Laydown area.
export const STAGING_NODES: IconNode = [
  [
    'path',
    {
      key: 'staging-0',
      d: 'M17 4.3999H7C6.44772 4.3999 6 4.84762 6 5.3999V13.3999C6 13.9522 6.44772 14.3999 7 14.3999H17C17.5523 14.3999 18 13.9522 18 13.3999V5.3999C18 4.84762 17.5523 4.3999 17 4.3999Z',
    },
  ],
  [
    'path',
    {
      key: 'staging-1',
      d: 'M9.3999 8.2002H14.5999',
    },
  ],
  [
    'path',
    {
      key: 'staging-2',
      d: 'M3 17.3999H21',
    },
  ],
  [
    'path',
    {
      key: 'staging-3',
      d: 'M6.5 19.5999V17.3999',
    },
  ],
  [
    'path',
    {
      key: 'staging-4',
      d: 'M12 19.5999V17.3999',
    },
  ],
  [
    'path',
    {
      key: 'staging-5',
      d: 'M17.5 19.5999V17.3999',
    },
  ],
]

export const StagingIcon: LucideIcon = createLucideIcon(
  'staging',
  STAGING_NODES,
)
